__turbopack_context__.v({
  "container": "Action-module__Q_K2ya__container",
  "icon": "Action-module__Q_K2ya__icon",
  "text": "Action-module__Q_K2ya__text",
});
